'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = DropdownButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = _button2.default.Group;

function DropdownButton(props) {
	var type = props.type,
	    className = props.className,
	    overlay = props.overlay,
	    trigger = props.trigger,
	    align = props.align,
	    onClick = props.onClick,
	    disabled = props.disabled,
	    visible = props.visible,
	    onVisibleChange = props.onVisibleChange,
	    placement = props.placement,
	    children = props.children,
	    other = (0, _objectWithoutProperties3.default)(props, ['type', 'className', 'overlay', 'trigger', 'align', 'onClick', 'disabled', 'visible', 'onVisibleChange', 'placement', 'children']);


	var cls = (0, _classnames2.default)((0, _defineProperty3.default)({
		'ant-dropdown-button': true,
		'mk-dropdown-button': true
	}, className, !!className));

	var dropdownProps = {
		align: align,
		overlay: overlay,
		trigger: disabled ? [] : trigger,
		onVisibleChange: onVisibleChange,
		placement: placement
	};

	if ('visible' in props) {
		dropdownProps.visible = visible;
	}

	return _react2.default.createElement(
		ButtonGroup,
		(0, _extends3.default)({}, other, { className: cls }),
		_react2.default.createElement(
			_button2.default,
			{ type: type, onClick: onClick, disabled: disabled },
			children
		),
		_react2.default.createElement(
			_index2.default,
			dropdownProps,
			_react2.default.createElement(
				_button2.default,
				{ type: type, disabled: disabled },
				_react2.default.createElement(_icon2.default, { type: 'down' })
			)
		)
	);
}
module.exports = exports['default'];